import { observer } from 'mobx-react'
import React, { useId } from 'react'

import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'

import { useMapsUtilityContext } from '../../../hooks/useMapsUtilityContext'
import MapTooltip from '../../MapTooltip/MapTooltip'

interface Props {
   errorMessage: string | null | undefined
   isGeoShapeChanged: boolean
   onSaveLocation: () => void
}

const SaveLocationTool = (props: Props): React.ReactElement => {
   const { errorMessage, isGeoShapeChanged, onSaveLocation } = props

   const { mapsT } = useMapsUtilityContext()

   const tooltipId = useId()

   if (!isGeoShapeChanged) return <></>

   return (
      <React.Fragment>
         <Button
            hierarchy={Hierarchy.Primary}
            size='Small'
            subVariant={SubVariant.Primary}
            isDisabled={!!errorMessage}
            onClick={onSaveLocation}
            className='shrink-0 !rounded-xl'
            data-tooltip-id={tooltipId}
         >
            {mapsT('saveLocation')}
         </Button>
         {errorMessage ? (
            <MapTooltip content={errorMessage} tooltipId={tooltipId} />
         ) : null}
      </React.Fragment>
   )
}

export default observer(SaveLocationTool)
